import { getLocale } from 'i18n/i18nUtils';

import { icfVersion } from '.';
import { DexfSettingsEnvironmentEnum } from '@inter-ikea-kompis/enums';

const dexfApiKey = import.meta.env.VITE_DEXF_API_KEY as string;

export const serviceSettings = {
  // Using StorageOne consumer here since no
  // new consumers will be created in IOWS due to forthcoming decommissioning
  consumer: 'StorageOne',
  contract: '42079',
  applicationName: 'SKYTTA',
  localizationPrefixApplication: 'SKYTTA',
  locale: getLocale(),
  // Transition to DEXF Settings and Phrase
  // https://i-p-e-x.atlassian.net/wiki/spaces/KOMPIS/blog/2023/11/01/36548706305/Transition+to+DEXF+Settings+and+Phrase#A-new-way-for-applications-to-interact-with-Kompis-Services
  //
  // The apps should always use the DEXF Settings Prod environment,
  // even when running in the QA environment for the app.
  // Only the segment should change.
  //
  // The app should be able to use the QA DEXF-API-KEY to fetch settings from the prod environment,
  // this is to prevent apps from having to switch between api-keys when calling different services.
  dexfApplicationId: 'skytta',
  dexfApiKey,
  dexfEnvironment: DexfSettingsEnvironmentEnum.production,
  // SKYT-1261: Update to version 1.1 that we have already created but maybe just forgot to change here
  dexfConfigurationVersion: '1.0',
  // This version HAS to be the same as the 'icf_version' property set in the actual ICF, otherwise dexf will silently ignore the ICF.
  dexfIcfVersion: icfVersion
};

export const translationEndpoints = [
  '/addon-app/translations/kompis/en-XZ.json',
  '/addon-app/translations/kompis/{language}-{country}.json',
  `/addon-app/skytta/translations/en-XZ.json`,
  `/addon-app/skytta/translations/{language}-{country}.json`
];
